import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { formatSignedDollars } from '~/utils/revenueOpportunities/formatOpportunityValues';
import { easeOutCubic } from '../../RevenueOpportunitiesSection.utils';
const LEAVE_MS = 120;
const ENTER_MS = 280;
const COUNT_UP_MS = 520;
const COUNT_UP_START_SHARE = 0.6;
const countUpAmount = (card, elapsedMs)=>{
    const share = COUNT_UP_START_SHARE + (1 - COUNT_UP_START_SHARE) * easeOutCubic(elapsedMs / COUNT_UP_MS);
    return formatSignedDollars(card.amountSign, Math.round(card.yearlyAmount * share));
};
const elapsedMsOf = (param)=>{
    let { startedAtMs, nowMs } = param;
    return startedAtMs == null ? null : nowMs - startedAtMs;
};
export const stillMotion = (card, nowMs)=>({
        identity: card.identity,
        card,
        leaving: null,
        startedAtMs: null,
        nowMs
    });
export const shownAmountOf = (motion)=>{
    if (motion.leaving != null) {
        return motion.leaving.amount;
    }
    const elapsedMs = elapsedMsOf(motion);
    return elapsedMs == null ? motion.card.amount : countUpAmount(motion.card, elapsedMs);
};
export const isEnteringAt = (motion)=>{
    const elapsedMs = elapsedMsOf(motion);
    return motion.leaving == null && elapsedMs != null && elapsedMs < LEAVE_MS + ENTER_MS;
};
export const swappedTo = (current, card, nowMs)=>{
    var _current_leaving;
    return {
        identity: card.identity,
        card,
        leaving: (_current_leaving = current.leaving) !== null && _current_leaving !== void 0 ? _current_leaving : {
            card: current.card,
            amount: shownAmountOf(current)
        },
        startedAtMs: nowMs,
        nowMs
    };
};
export const advancedTo = (current, nowMs)=>{
    var _current_startedAtMs;
    const elapsedMs = nowMs - ((_current_startedAtMs = current.startedAtMs) !== null && _current_startedAtMs !== void 0 ? _current_startedAtMs : nowMs);
    if (elapsedMs >= COUNT_UP_MS) {
        return stillMotion(current.card, nowMs);
    }
    return _object_spread_props(_object_spread({}, current), {
        leaving: elapsedMs < LEAVE_MS ? current.leaving : null,
        nowMs
    });
};
